import { addDays, format } from "date-fns";
import {
    GetNewsEditRealestates,
    GetNewsEditRealestates_currentRealestate
} from "src/api/generated/GetNewsEditRealestates";
import { ISelectableRealestate } from "src/stores/RealestateStore";

const DATE_INPUT_FORMAT = "yyyy-MM-dd";

export const getDateInputValue = (date: Date): string => format(date, DATE_INPUT_FORMAT);

export const getTomorrowDateInputValue = (date: Date = new Date()): string => getDateInputValue(addDays(date, 1));

export const isPublishfromDateInvalid = (publishfrom?: string | null, today: Date = new Date()): boolean => {
    if (!publishfrom) return false;

    return publishfrom <= getDateInputValue(today);
};

export interface INewsRealestateSelection {
    realestates: ISelectableRealestate[];
    // Realestates of the news the user has no access to. They are not shown, but kept when saving.
    inaccessibleRealestateIds: string[];
}

const toSelectableRealestate = (realestate: GetNewsEditRealestates_currentRealestate): ISelectableRealestate => ({
    id: realestate.id,
    name: realestate.name,
    number: realestate.number,
    consolidationid: realestate.consolidationid ?? undefined
});

// An existing news keeps its realestates. A new news starts with the realestate it was opened from.
export const getInitialNewsRealestateSelection = ({
    newsrealestates,
    currentRealestate
}: GetNewsEditRealestates): INewsRealestateSelection => {
    if (newsrealestates.length === 0) {
        return { realestates: currentRealestate.map(toSelectableRealestate), inaccessibleRealestateIds: [] };
    }

    return {
        realestates: newsrealestates.flatMap(({ realestate }) =>
            realestate ? [toSelectableRealestate(realestate)] : []
        ),
        inaccessibleRealestateIds: newsrealestates
            .filter(({ realestate }) => !realestate)
            .map(({ realestateid }) => realestateid)
    };
};

// Micro.News adds the old field realestateid to the list, so with the flag only the list is sent.
// Otherwise the realestate from the URL could never be removed.
export const getNewsRealestateRequestFields = (
    hasFeatureFlagNews: boolean,
    realestateid: string,
    realestates: ISelectableRealestate[],
    inaccessibleRealestateIds: string[]
) =>
    hasFeatureFlagNews
        ? { realestateids: [...realestates.map((realestate) => realestate.id), ...inaccessibleRealestateIds] }
        : { realestateid };
